import React from 'react';

const Ogolne = (props) => {
  return (
    <React.Fragment>
      <h5 className="page-header firstColor ">
        <b>Grupowe Ubezpieczenie TUW PZUW Opieka Medyczna</b> to profesjonalna{' '}
        <b>opieka medyczna</b>, <br />w renomowanych placówkach medycznych w
        całej Polsce dla Ciebie i członków Twojej rodziny.
      </h5>
      <div className="row">
        <div className="col-sm-6 secondColor">
          <b className="firstColor">
            W ramach Pakietów Medycznych TUW PZUW otrzymujesz:
          </b>
          <ul className="listIcons okCircle mt-3">
            <li>
              wizyty u wykwalifikowanych specjalistów <b>bez skierowań</b>
            </li>
            <li>
              dostęp do szerokiego katalogu{' '}
              <b>specjalizacji, badań i zabiegów</b>, również na podstawie
              skierowania wystawionego poza siecią PZU
            </li>
            <li>
              <b>gwarancję krótkiego terminu</b> realizacji wizyty: u{' '}
              <b>lekarza POZ</b> (internista, lekarz rodzinny, pediatra)
              maksymalnie <b>2 dni</b> robocze, a u <b>specjalisty</b> do{' '}
              <b>5 dni</b> roboczych*
            </li>
            <li>
              dostęp do <b>telekonsultacji medycznych</b> nawet do{' '}
              <b>24 specjalizacji</b>, również podczas przebywania poza
              granicami Polski
            </li>
          </ul>
        </div>
        <div className="col-sm-6 secondColor">
          <b className="firstColor">
            Masz możliwość wyboru wariantu opieki w ramach dostępnych pakietów i
            zakresów:
          </b>
          <br />
          <br />
          <b>Zakresy</b>
          <ul className="dashedList">
            <li>Komfort</li>
            <li>Komfort Plus</li>
            <li>Optimum</li>
            <li>Komfort - dedykowany dla pakietu Senior i Dorosłe Dziecko</li>
          </ul>
          <b>Rodzaje pakietów</b>
          <br />
          <br />
          <ol>
            <li>
              <b>Pakiet indywidualny</b> - dla Pracownika
            </li>
            <li>
              <b>Pakiet partnerski</b> - dla Pracownika i jednego członka
              najbliższej rodziny Pracownika (tj. małżonka/partnera życiowego
              albo dziecka, które nie ukończyło 26 roku życia).
            </li>
            <li>
              <b>Pakiet rodzinny</b> - dla Pracownika oraz wszystkich członków
              najbliższej rodziny Pracownika (małżonka/partnera życiowego i
              dzieci, które nie ukończyły 26 roku życia).
            </li>
            <li>
              <b>Pakiet Dorosłe Dziecko</b> - dla dorosłego dziecka, które
              ukończyło 26 rok życia - dostępny zakres Komfort Dorosłe Dziecko
            </li>
            <li>
              <b>Pakiet Senior</b> - dla rodzica pracownika i rodzica partnera
              życiowego pracownika, który nie ukończył 80 roku życia - dostępny
              zakres Komfort Senior
            </li>
          </ol>
          <br />
        </div>

        <div
          style={{ fontSize: 'small', textAlign: 'justify' }}
          className="secondColor">
          * Wskazane terminy dostępności obowiązują po uprzednim umówieniu
          konsultacji poprzez infolinię (opłata zgodna z taryfą operatora),
          zgodnie z przysługującym zakresem ubezpieczenia oraz we wskazanej
          przez TUW PZUW placówce medycznej. Wskazane terminy nie dotyczą okresu
          obowiązywania stanu epidemii, pandemii lub stanu zagrożenia
          epidemicznego, a także innych sytuacji (ogólnopolskich, światowych lub
          lokalnych), w których placówki nie mają możliwości przyjmować
          pacjentów w tradycyjnej formie (z uwagi na zarządzenie organów
          państwa, samorządu lub bezpieczeństwo pacjentów lub personelu
          medycznego) i realizują świadczenia w formie konsultacji
          telefonicznych lub innej bezkontaktowej formie.
        </div>
      </div>
      <br />
      <div className="text-white p-2 sixthColor iconFromLeft moneyIcon">
        <h5 className="firstColor">
          <b>Składka za ubezpieczenie</b>
        </h5>
      </div>
      <br />
      <table className="table table-bordered secondColor">
        <tbody className="text-center">
          <tr className=" firstColor">
            <th colSpan={2} className="col-sm-4">
              PAKIET ZDROWOTNY DLA PRACOWNIKÓW <br />
              (opłata za miesiąc)
            </th>
            <th className="col-sm-2">Komfort</th>
            <th className="col-sm-2">Komfort Plus</th>
            <th className="col-sm-2">Optimum</th>
          </tr>
          <tr className="tableBackgroundRow">
            <th rowSpan={3}>
              Pakiet Indywidualny
              <small>
                <sup>1</sup>
              </small>
              <br />
              <small>(tylko pracownik)</small>
            </th>
            <th>Koszt pakietu</th>
            <th>182,00 zł</th>
            <th>285,00 zł</th>
            <th>585,00 zł</th>
          </tr>
          <tr className="tableBackgroundRow">
            <th>
              <small>
                <i>
                  Pracownik uprawniony do zakresu Komfort<sup>2</sup>
                </i>
              </small>
            </th>
            <th>
              <small>
                <i>Pakiet finansowany przez TVP</i>
              </small>
            </th>
            <th>
              <small>
                <i>Dopłata pracownika 103,00 zł</i>
              </small>
            </th>
            <th>
              <small>
                <i>Dopłata pracownika 403,00 zł</i>
              </small>
            </th>
          </tr>
          <tr className="tableBackgroundRow">
            <th>
              <small>
                <i>
                  Pracownik uprawniony do zakresu Komfort Plus<sup>2</sup>
                </i>
              </small>
            </th>
            <th>
              <small>-</small>
            </th>
            <th>
              <small>
                <i>Pakiet finansowany przez TVP - dla osób uprawnionych</i>
              </small>
            </th>
            <th>
              <small>
                <i>Dopłata pracownika 300,00 zł</i>
              </small>
            </th>
          </tr>
          <tr>
            <th colSpan={2}>
              Pakiet Partnerski
              <small>
                <sup>3</sup>
              </small>
              <br />
              <small>
                (dla 1 członka rodziny tj. małżonka/partnera lub dziecka do 26
                r.ż.)
                <br />- finansowany przez Pracownika
              </small>
            </th>
            <th>+ 284,60 zł</th>
            <th>+ 349,30 zł</th>
            <th>+ 716,90 zł</th>
          </tr>
          <tr className="tableBackgroundRow">
            <th colSpan={2}>
              Pakiet Rodzinny
              <small>
                <sup>3</sup>
              </small>
              <br />
              <small>
                (dla wszystkich członków rodziny tj. małżonka/partnera oraz
                dziecka do 26 r.ż.)
                <br />- finansowany przez Pracownika
              </small>
            </th>
            <th>+ 573,60 zł</th>
            <th>+ 791,80 zł</th>
            <th>+ 1625,20 zł</th>
          </tr>
          <tr>
            <th colSpan={5} className="text-center">
              Oddzielna deklaracja na każdego ubezpieczonego:
            </th>
          </tr>
          <tr>
            <th colSpan={2}>
              Komfort Senior
              <small>
                <sup>4</sup>
              </small>
              <br />
            </th>
            <th>266,40 zł</th>
            <th>-</th>
            <th>-</th>
          </tr>
          <tr className="tableBackgroundRow">
            <th colSpan={2}>
              Komfort Dorosłe Dziecko
              <small>
                <sup>4</sup>
              </small>
              <br />
            </th>
            <th>327,70 zł</th>
            <th>-</th>
            <th>-</th>
          </tr>
        </tbody>
      </table>
      <small>
        1. Koszt prywatnej opieki medycznej finansowanej przez pracodawcę
        stanowi podstawę wymiaru składek na ubezpieczenia społeczne oraz
        naliczania podatku dochodowego od osób fizycznych zgodnie z
        obowiązującymi przepisami prawa.
        <br />
        <small>
          <b>
            W związku ze zmianą składki za ubezpieczenie, od 1 stycznia 2026 r.
            należne obciążenia będą wyższe niż do tej pory.
          </b>
        </small>
      </small>
      <br />

      <small>2. Zasady finansowania zakresu Komfort Plus – patrz poniżej</small>
      <br />
      <small>
        3. Składka płatna dodatkowo, potrącana z wynagrodzenia, na podstawie
        pisemnej zgody pracownika.
      </small>
      <br />
      <small>
        4. Składka płatna dodatkowo - nie potrącana z wynagrodzenia. Wpłata na
        indywidualne konto, wskazane w deklaracji przystąpienia
        współubezpieczonego (Seniora lub Dorosłego Dziecka).
      </small>
      <br />
      <br />
      {/* <p
        className="small"
        style={{ textAlign: 'justify', textAlignLast: 'left' }}>
        * Wskazane terminy dostępności obowiązują po uprzednim umówieniu
        konsultacji poprzez infolinię (opłata zgodna z taryfą operatora),
        zgodnie z przysługującym zakresem ubezpieczenia oraz we wskazanej przez
        TUW PZUW placówce medycznej. Wskazane terminy nie dotyczą okresu
        obowiązywania stanu epidemii, pandemii lub stanu zagrożenia
        epidemicznego, a także innych sytuacji (ogólnopolskich, światowych lub
        lokalnych), w których placówki nie mają możliwości przyjmować pacjentów
        w tradycyjnej formie (z uwagi na zarządzenie organów państwa, samorządu
        lub bezpieczeństwo pacjentów lub personelu medycznego) i realizują
        świadczenia w formie konsultacji telefonicznych lub innej bezkontaktowej
        formie.
      </p> */}
      <br />

      <b className="firstColor">
        Zasady finansowania pakietów przez Pracodawcę:
      </b>
      <br />
      <ul className="secondColor">
        <li>
          <b>Zakres Komfort - indywidualny</b> - jest finansowany wszystkim
          Pracownikom Spółki
        </li>
        <li>
          <b>Zakres Komfort Plus - indywidualny</b> - jest finansowany
          uczestnikom Programu „Pełnosprawne Partnerstwo", osobom, które
          ukończyły 55 rok życia oraz posiadają nieprzerwane związanie umową o
          pracę z Ubezpieczającym przez ostatnie pięć lat, a także dyrektorom i
          ich zastępcom.
        </li>
      </ul>
    </React.Fragment>
  );
};

export default Ogolne;
